exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3 {\n  font-family: \"browallia\", FontAwesome;\n  color: red; }\n\n.col-6 {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 55%;\n  flex: 0 0 55%;\n  max-width: 55%; }\n\n.col-5-print {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 45%;\n  flex: 0 0 45%;\n  max-width: 45%; }\n\n.printTrading {\n  background-color: #ffffff;\n  zoom: 0.69; }\n\n#tradingToPeerPrint {\n  padding-right: 1rem !important; }\n\n#tradingStatisticPrint th {\n  padding: 0 !important; }\n\n.page-break-cash {\n  page-break-after: always; }\n\n.page-break-trading {\n  page-break-before: always; }\n\n.tradingToPeerPrint {\n  padding-top: 1.5rem; }\n\n.tradingToPeer {\n  padding-top: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/trading/trading.component.scss
// module id = ../../../../../src/app/securities-level/trading/trading.component.scss
// module chunks = main